var exports = {
  "k": "xe564cbfb--0d8dc4--container",
};

module.exports = exports;
